// extracted by mini-css-extract-plugin
export default {"formBuilderCard":"style__formBuilderCard___dsIGo","preview":"style__preview___p5pqo","singleLineText":"style__singleLineText___yktj_"};